import React, { useEffect, useState } from 'react'
import { ReactFlowShapes } from '../../Components/ReactFlowShapes/ReactFlowShapes';
import { ICustomTableNode } from '../../Components/ReactFlowShapes/ReactFlowShapes.types';
import { Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { IStoreState, useAppDispatch, useAppSelector } from '../../redux';
import { clearTablesLayoutStateSync, fetchOutletSingleLayoutAsync, upsertSingleTableLayoutAsync } from '../../redux/tables';
import { useOutletContext } from '../../providers';


export const TableMenuLayout: React.FC<{ onModeChange: () => void }> = ({ onModeChange }) => {
    const { uuid: layoutUUID } = useParams<{ uuid?: string }>();
    const navigate = useNavigate()
    const dispatch = useAppDispatch();
    const { outlet_details: { outlet_uuid, outlet_name } } = useOutletContext()

    const {
        data: tableData,
        loading,
    } = useAppSelector((storeState: IStoreState) => storeState.tables.single_tables_layout);

    const [initialNodes, setInitialNodes] = useState<ICustomTableNode[]>([])

    useEffect(() => {
        if (outlet_uuid && layoutUUID)
            dispatch(fetchOutletSingleLayoutAsync(layoutUUID))
        return () => {
            dispatch(clearTablesLayoutStateSync())
        }
    }, [outlet_uuid, layoutUUID])

    React.useEffect(() => {
        setInitialNodes(tableData.tables)
    }, [tableData]);


    const handleSaveButtonClick = (data: ICustomTableNode[]) => {
        dispatch(upsertSingleTableLayoutAsync({
            ...tableData,

            tables: data
        })).then((res) => {
            if (res.meta.requestStatus === "fulfilled") {
                handleCloseLayout()
            }
        });
    }

    const handleCloseLayout = () => {
        onModeChange()
    }


    return (
        <Box sx={{
            height: "80vh"
        }}>
            <ReactFlowShapes
                theme='light'
                initialNodes={initialNodes}
                onSaveClick={handleSaveButtonClick}
                onCancel={handleCloseLayout}
            />
        </Box>
    )
}
